import * as actions from './productionItemIssue/actions'
import * as mutations from './productionItemIssue/mutations'
import * as getters from './productionItemIssue/getters'

import { dataProps } from './productionItemIssue/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/productionItemIssue.js